export default __webpack_public_path__ + "4ae0a86927d702258f2435e048bd5b39.webp";